export const queryKeys = {
  pageContent: (page, language) => ["pageContent", page, language],
  pageContentAliases: (aliases, language) => ["pageContentAliases", aliases, language],
  productsExploreSection: (language) => ["productsExploreSection", language],
  publicSolutions: (language) => ["publicSolutions", language],
  publicSectors: (language) => ["publicSectors", language],
  publicSectorBySlug: (slug, language) => ["publicSectorBySlug", slug, language],
  downloadsDocuments: (language) => ["downloadsDocuments", language],
  blogPosts: (language) => ["blogPosts", language],
};
